import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueMeta from 'vue-meta'

import 'normalize.css/normalize.css'
import './styles/index.scss'

// if (process.env.NODE_ENV === "development") {
// const { mockXHR } = require('../mock')
// mockXHR()
// }
Vue.use(VueMeta)
Vue.config.productionTip = false

new Vue({
  router,
  store,

  metaInfo() {
    return {
      title: this.$store.state.myVueMeta.metaInfo.title,
      meta: [
        {
          name: 'keywords',
          content: this.$store.state.myVueMeta.metaInfo.keywords
        },
        {
          name: 'description',
          content: this.$store.state.myVueMeta.metaInfo.description
        }
      ]
    }
  },
  render: (h) => h(App)
}).$mount('#app')
